/**
 * Suggest given names / surnames from a full name (P16b G1, Pedro 2026-10-10).
 *
 * Pedro's rule: with 4 or more words the first TWO are the given names; with 3 or fewer
 * the first ONE is. The particles da / de / do / dos / das / e stay with the surname
 * that follows them, so a given part ending in a particle gives that word back:
 *   "Ana Maria da Silva Santos" → "Ana Maria" | "da Silva Santos"
 *   "José de Sousa Lima"        → "José"      | "de Sousa Lima"
 *   "Ana da Silva"              → "Ana"       | "da Silva"
 * It is only a suggestion: the person (or a reviewer) confirms or corrects it, and the
 * two parts are edited on their own afterwards ("suggest, then separate").
 */
const PARTICLES = new Set(['da', 'de', 'do', 'dos', 'das', 'e']);

export function suggestNameSplit(full: string | null | undefined): { given: string; surnames: string } {
  const words = (full ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return { given: '', surnames: '' };
  if (words.length === 1) return { given: words[0], surnames: '' };
  let n = words.length >= 4 ? 2 : 1;
  while (n > 1 && PARTICLES.has(words[n - 1].toLowerCase())) n -= 1;
  return { given: words.slice(0, n).join(' '), surnames: words.slice(n).join(' ') };
}

/** The full name a display name would be filled with ("suggest, then separate"). */
export function joinName(given: string | null | undefined, surnames: string | null | undefined): string {
  return [given, surnames].map((s) => (s ?? '').trim()).filter(Boolean).join(' ');
}
